import { render, staticRenderFns } from "./BadgeDetailCard.vue?vue&type=template&id=688d03e4&scoped=true&"
import script from "./BadgeDetailCard.vue?vue&type=script&lang=js&"
export * from "./BadgeDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./BadgeDetailCard.vue?vue&type=style&index=0&id=688d03e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d03e4",
  null
  
)

export default component.exports